module.exports = __webpack_public_path__ + "img/picture_notmember_screenshot_WEB.70b7e58c.png";